<template>
  <v-layout row justify-space-between>

    <v-flex class="mr-2">
      <v-sheet color="grey lighten-3">
        <v-layout row pa-3>
          <v-flex v-if="employee.profile_picture_url" mr-3 mb-2>
            <v-img min-width="200" contain
              :src="employee.profile_picture_url"
            >
            </v-img>
          </v-flex>
          <v-flex shrink>
            <h2 class="all-caps">Bio</h2>
            <div v-if="employee.bio" style="max-width: 300px;">
              <p class="with-newlines">{{ employee.bio }}</p>
            </div>
            <div v-else class="subtle">
              <p>No bio entered</p>
            </div>
          </v-flex>
        </v-layout>
      </v-sheet>
    </v-flex>

    <v-flex>
      <div class="mb-3">
        <h2>Experience:</h2>
        <div v-if="employee.global_skills.length > 0">
          <ul class="unstyled">
            <li class="subtle body-2" v-for="skill in employee.global_skills">
              {{ skill }}
            </li>
          </ul>
        </div>
        <div v-else class="subtle">
          None
        </div>
      </div>
      <div>
        <h2>Certifications:</h2>
        <div v-if="employeeCertifications.length > 0 || employeeInsurances > 0">
          <ul class="unstyled">
            <li class="subtle body-2" v-for="cert in employeeCertifications">
              {{ cert.certification_type }}
            </li>
            <li class="subtle body-2" v-for="ins in employeeInsurances">
              {{ ins.certification_type }}
            </li>
          </ul>
        </div>
        <div v-else class="subtle">
          None
        </div>
      </div>
    </v-flex>

  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Info from '@/components/hr/info.vue'
import EmployeeField from '@/components/hr/employee-field.vue'
import EmployeeDateField from '@/components/hr/employee-date-field.vue'
import EmployeeCheckboxField from '@/components/hr/employee-checkbox-field.vue'
import Uploader from '@/components/hr/uploader.vue'
import ImagePreview from '@/components/hr/image-preview.vue'

export default {
  components: {
    Info,
    EmployeeField,
    EmployeeDateField,
    EmployeeCheckboxField,
    Uploader,
    ImagePreview
  },
  props: [
    'employee'
  ],
  computed: {
    ...mapGetters('employees', [
      'employeeCertifications',
      'employeeInsurances',
    ]),
  },
  methods: {
  },
  data: function() {
    return {
    }
  },
}
</script>
